import React from "react";
import { Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

interface CriterionRowEditModeProps {
  editingCriterionData: {
    name: string;
    description: string;
    tenant: string;
  } | null;
  currentTenant: string;
  setEditingCriterionData: (data: { name: string; description: string; tenant: string } | null) => void;
  setEditingCriterionId: (id: string | null) => void;
  onSave: () => void;
}

export const CriterionRowEditMode: React.FC<CriterionRowEditModeProps> = ({
  editingCriterionData,
  currentTenant,
  setEditingCriterionData,
  setEditingCriterionId,
  onSave,
}) => {
  return (
    <div className="al-space-y-4">
      <div className="al-mb-3">
        <label
          htmlFor="edit-criterion-name"
          className="al-text-xs al-font-semibold al-text-purple-700 al-uppercase al-mb-1 al-block"
        >
          Criterion Name
          <input
            id="edit-criterion-name"
            type="text"
            value={editingCriterionData?.name || ""}
            onChange={e =>
              setEditingCriterionData({
                ...editingCriterionData!,
                name: e.target.value,
              })
            }
            className="al-w-full al-border al-border-purple-200 al-bg-purple-50 al-rounded-lg al-p-3 al-text-sm al-font-normal al-text-gray-900 focus:al-border-purple-300 focus:al-outline-none focus:al-ring-2 focus:al-ring-purple-100 al-mt-1"
          />
        </label>
      </div>

      <div className="al-mb-3">
        <label
          htmlFor="edit-criterion-description"
          className="al-text-xs al-font-semibold al-text-purple-700 al-uppercase al-mb-1 al-block"
        >
          Description
          <textarea
            id="edit-criterion-description"
            value={editingCriterionData?.description || ""}
            onChange={e =>
              setEditingCriterionData({
                ...editingCriterionData!,
                description: e.target.value,
              })
            }
            rows={4}
            className="al-w-full al-border al-border-purple-200 al-bg-purple-50 al-rounded-lg al-p-3 al-text-sm al-font-normal al-text-gray-900 focus:al-border-purple-300 focus:al-outline-none focus:al-ring-2 focus:al-ring-purple-100 al-mt-1"
          />
        </label>
      </div>

      <div className="al-mb-3">
        <div className="al-text-xs al-font-semibold al-text-amber-700 al-uppercase al-mb-1">
          Tenant Visibility
        </div>
        <div className="al-bg-amber-50 al-border al-border-amber-200 al-p-3 al-rounded-lg al-space-y-2">
          <label htmlFor="edit-tenant-all" className="al-cursor-pointer">
            <Stack direction="row" align="center" gap="lg">
              <input
                id="edit-tenant-all"
                type="radio"
                name="tenant-visibility"
                checked={editingCriterionData?.tenant === "All"}
                onChange={() =>
                  setEditingCriterionData({
                    ...editingCriterionData!,
                    tenant: "All",
                  })
                }
                className="al-w-4 al-h-4 al-text-amber-600 focus:al-ring-amber-500"
              />
              <span className="al-text-sm al-text-gray-700 al-ml-3">
                All Tenants
              </span>
            </Stack>
          </label>
          {currentTenant && (
            <label htmlFor="edit-tenant-current" className="al-cursor-pointer">
              <Stack direction="row" align="center" gap="lg">
                <input
                  id="edit-tenant-current"
                  type="radio"
                  name="tenant-visibility"
                  checked={editingCriterionData?.tenant !== "All"}
                  onChange={() =>
                    setEditingCriterionData({
                      ...editingCriterionData!,
                      tenant: currentTenant || "All",
                    })
                  }
                  className="al-w-4 al-h-4 al-text-amber-600 focus:al-ring-amber-500"
                />
                <span className="al-text-sm al-text-gray-700 al-ml-3">
                  {currentTenant || "Current Tenant"} Only
                </span>
              </Stack>
            </label>
          )}
        </div>
      </div>

      <Stack
        direction="row"
        gap="sm"
        justify="end"
        className="al-mt-4"
      >
        <Button
          onClick={() => {
            setEditingCriterionId(null);
            setEditingCriterionData(null);
          }}
          variant="outline"
          size="sm"
        >
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="default"
          size="sm"
          disabled={
            !editingCriterionData?.name ||
            !editingCriterionData?.description
          }
        >
          Save
        </Button>
      </Stack>
    </div>
  );
};
